import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutV3 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return <section className="about-three  go-top">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-6">
		        <img src={publicUrl+"assets/images/resources/robo-1.png"} className="about-three__moc" alt={ imagealt } />
		      </div>{/* /.col-lg-6 */}
		      <div className="col-lg-6">
		        <div className="about-three__content">
		          <div className="block-title-two text-left">
		            <h3>Our Target</h3>
		          </div>{/* /.block-title-two */}
		          <p>An intelligent conversational platform that engages your customers, captures leads, and streamlines communication </p>
		          <h4>Started With Us</h4>
		          <p>Smarter Technology. Safer Design. Seamless Experience. Converzex is not just an automation tool; it’s
					  Your intelligent growth partner.
				  </p>
		          <Link to="/about" className="thm-btn about-three__btn">Read More <i className="fa fa-angle-double-right" /></Link>
		          {/* /.thm-btn about-three__btn */}
		        </div>{/* /.about-three__content */}
		      </div>{/* /.col-lg-6 */}
		    </div>{/* /.row */}
		  </div>{/* /.container */}
		</section>


        }
}

export default AboutV3